<template>
    <ApexChart
            type="line"
            height="350"
            :options="options"
            :series="series">
    </ApexChart>
</template>

<script>
import ApexChart from "vue-apexcharts";

export default {
    name: "ExportRequestLatencyResponseChart",
    components: {ApexChart},
    props:{
        statistics:{
            type: Array
        }
    },
    data(){
        return {
            optionsDefault: {}
        }
    },
    computed:{
        series(){
            return [
                {
                    name: 'Задержка Export (сек)',
                    data: this.statistics.map((item) => item.avg_latency)
                },
                {
                    name: 'Кол-во ответов',
                    data: this.statistics.map((item) => item.cnt_responses)
                },
                {
                    name: 'Кол-во запросов',
                    data: this.statistics.map((item) => item.cnt_requests)
                },
                {
                    name: '90percentile',
                    data: this.statistics.map((item) => item['90_percentile'])
                },
                {
                    name: '50percentile',
                    data: this.statistics.map((item) => item['50_percentile'])
                },
            ];
        },
        options(){
            return {
                title: {
                    text: 'Среднее время(сек) ответов от ГИС',
                    align: 'left'
                },
                xaxis: {
                    categories: this.statistics.map((item) => item.datetime)
                }
            };
        }
    }
}
</script>

<style scoped>

</style>